const Wish = {
  HAS: 1,
  NO_HAS: 0,
  UNKNOW: 2,
};

export default Wish;
